import models from "modules/models";
import BaseRxApiService from "./baseRxApiService";

export default class ServiceRxApiService extends BaseRxApiService {
  constructor() {
    super(models.SERVICE);
  }
}
